import Paper from "@components/Paper/Paper";
import PaperItem from "@components/Paper/PaperItem";
import MarpolAnnexGrid from "@features/vessel-call/vessel-call-status/PortServices/preview/MarpolAnnexGrid";
import type { PortService } from "@services/port-services/types";
import { t } from "i18next";

const TEST_ID_BASE = "port-services-preview";
const wrapperStyleClass = "border-b border-[#F1F2F4] pb-3";
const transStyleClass = "font-normal text-[#646A77]";

interface SludgeFieldsProps {
  langBase: string;
  portServiceDetails: PortService;
}

const SludgeFields: React.FC<SludgeFieldsProps> = ({ langBase, portServiceDetails }) => {
  return (
    <>
      <Paper variant="outlined">
        <p className="font-bold">{t(`${langBase}.registered-agent`)}</p>
        <div className="grid grid-cols-2">
          <div className="mr-4">
            <PaperItem
              testId={`${TEST_ID_BASE}-registered-agent-name`}
              translate={t(`${langBase}.name`)}
              textStyles="font-medium"
              tranStyle={transStyleClass}
              wrapperStyle={wrapperStyleClass}
              text={portServiceDetails.registeredAgentName || "-"}
            />
          </div>
          <PaperItem
            testId={`${TEST_ID_BASE}-registered-agent-contact-person`}
            translate={t(`${langBase}.contact-person`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.registeredAgentContactPerson || "-"}
          />
        </div>
      </Paper>
      <Paper variant="outlined">
        <p className="font-bold">{t(`${langBase}.intended-operation`)}</p>
        <div className="grid grid-cols-2">
          <div className="mr-4">
            <PaperItem
              testId={`${TEST_ID_BASE}-service-provider-name`}
              translate={t(`${langBase}.service-provider-name`)}
              textStyles="font-medium"
              tranStyle={transStyleClass}
              wrapperStyle={wrapperStyleClass}
              text={portServiceDetails.serviceProviderName || "-"}
            />
            <PaperItem
              testId={`${TEST_ID_BASE}-number-of-skips`}
              translate={t(`${langBase}.number-of-skips`)}
              textStyles="font-medium"
              tranStyle={transStyleClass}
              wrapperStyle={wrapperStyleClass}
              text={portServiceDetails.numberOfSkips || "-"}
            />
          </div>
          <div className="mr-4">
            <PaperItem
              testId={`${TEST_ID_BASE}-operation-location`}
              translate={t(`${langBase}.operation-location`)}
              textStyles="font-medium"
              tranStyle={transStyleClass}
              wrapperStyle={wrapperStyleClass}
              text={portServiceDetails.operationLocation || "-"}
            />
          </div>
          <div className="col-span-2">
            <PaperItem
              testId={`${TEST_ID_BASE}-details-of-intended-operation`}
              translate={t(`${langBase}.details-of-intended-operation`)}
              textStyles="font-medium"
              tranStyle={transStyleClass}
              wrapperStyle={wrapperStyleClass}
              labelClassName="w-1/4"
              valueClassName="w-3/4"
              text={portServiceDetails.intendedOperationDetails || "-"}
            />
          </div>
        </div>
      </Paper>
      <MarpolAnnexGrid rows={portServiceDetails?.wasteResiduesForDischargeFacility} />
    </>
  );
};

export default SludgeFields;
